import { renderLocationSidebar } from './locationSidebar';

export const EVENTS_TEMPLATE = `
<div class="flex h-screen overflow-hidden bg-background-light">
${renderLocationSidebar('events')}
<main class="ml-64 flex-1 overflow-hidden flex flex-col">
  <div class="flex-1 overflow-auto p-8">
    <div class="flex items-end justify-between mb-8">
      <div>
        <h1 class="text-3xl font-black text-slate-900 tracking-tight">Events</h1>
        <p class="mt-1 text-sm text-slate-500">Manage all motorcycle tours, rallies, and community rides</p>
      </div>
      <a href="/events/create" class="inline-flex items-center gap-2 h-11 px-6 rounded-lg bg-primary text-white font-bold shadow-sm shadow-primary/20 hover:bg-primary/90 transition-colors">
        <span class="material-symbols-outlined text-[20px]">add</span>
        <span>Create Event</span>
      </a>
    </div>

    <section class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mb-8">
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Upcoming</p>
        <p id="events-kpi-upcoming" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Pending Review</p>
        <p id="events-kpi-pending" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Published</p>
        <p id="events-kpi-published" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Cancelled/Finished</p>
        <p id="events-kpi-finished" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
    </section>

    <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div class="p-4 border-b border-slate-100 flex flex-wrap gap-3 items-center">
        <div class="relative flex-1 min-w-[260px]">
          <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
          <input id="events-search-input" class="w-full h-10 pl-10 pr-4 rounded-lg bg-slate-50 border border-slate-200 text-sm placeholder:text-slate-400 focus:border-primary focus:ring-primary" placeholder="Search events..." />
        </div>

        <select id="events-origin-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Origin: All</option>
          <option value="official">Official</option>
          <option value="community">Community</option>
        </select>

        <select id="events-status-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Status: All</option>
          <option value="draft">Draft</option>
          <option value="pending_review">Pending Review</option>
          <option value="published">Published</option>
          <option value="rejected">Rejected</option>
          <option value="cancelled">Cancelled</option>
          <option value="finished">Finished</option>
        </select>

        <select id="events-type-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Type: All</option>
        </select>

        <select id="events-ordering-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="starts_at">Starts At (Oldest)</option>
          <option value="-starts_at">Starts At (Newest)</option>
          <option value="-created_at">Created (Newest)</option>
          <option value="title">Title (A-Z)</option>
          <option value="-rsvp_going_count">RSVP (Most Going)</option>
        </select>
        <button id="events-reset-filters-btn" class="h-10 px-3 rounded-lg border border-slate-200 text-sm font-semibold text-primary hover:bg-primary/5" type="button">Reset</button>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-left">
          <thead class="bg-slate-50 text-slate-500 uppercase text-[10px] font-bold tracking-wider">
            <tr>
              <th class="px-4 py-4">ID</th>
              <th class="px-4 py-4">Event</th>
              <th class="px-4 py-4">Origin</th>
              <th class="px-4 py-4">Type</th>
              <th class="px-4 py-4">Date & Time</th>
              <th class="px-4 py-4">Location</th>
              <th class="px-4 py-4">Status</th>
              <th class="px-4 py-4">RSVP</th>
              <th class="px-4 py-4 text-right">Actions</th>
            </tr>
          </thead>
          <tbody id="events-table-body" class="divide-y divide-slate-100 text-sm">
            <tr>
              <td class="px-4 py-6 text-slate-500" colspan="9">Loading events...</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="border-t border-slate-100 px-4 py-3 flex items-center justify-between gap-4">
        <p class="text-xs text-slate-500 font-medium" id="events-table-meta">Showing 0 events</p>
        <div class="flex items-center gap-2">
          <button id="events-prev-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Prev</button>
          <span id="events-page-indicator" class="text-xs font-semibold text-slate-500 min-w-[72px] text-center">Page 1</span>
          <button id="events-next-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Next</button>
        </div>
      </div>
    </section>
  </div>
</main>
</div>

<div id="events-view-overlay" class="fixed inset-0 z-[70] hidden">
  <div id="events-view-backdrop" class="absolute inset-0 bg-slate-900/30"></div>
  <aside class="absolute right-0 top-0 h-full w-full md:w-1/2 bg-white shadow-2xl border-l border-slate-200 overflow-y-auto">
    <div class="sticky top-0 z-10 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
      <div>
        <h2 id="events-view-title" class="text-2xl font-black text-slate-900">Event</h2>
        <p id="events-view-subtitle" class="text-xs text-slate-500 mt-1">ID: -</p>
      </div>
      <button id="events-view-close-btn" class="p-2 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100" type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="p-6 space-y-5">
      <div id="events-view-error" class="hidden rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700"></div>

      <div class="h-56 rounded-xl overflow-hidden border border-slate-200 bg-slate-100">
        <img id="events-view-hero" class="w-full h-full object-cover" alt="Event cover" src=""/>
      </div>
      <div id="events-view-gallery" class="grid grid-cols-4 gap-2"></div>

      <div class="flex flex-wrap items-center gap-2">
        <span id="events-view-status" class="px-2.5 py-1 rounded-lg text-xs font-bold uppercase bg-slate-100 text-slate-700">Draft</span>
        <span id="events-view-origin" class="px-2.5 py-1 rounded-lg text-xs font-bold uppercase bg-primary/10 text-primary">Official</span>
        <span id="events-view-featured" class="px-2.5 py-1 rounded-lg text-xs font-bold uppercase bg-amber-100 text-amber-700">Not Featured</span>
      </div>

      <div class="grid grid-cols-2 gap-3 text-sm">
        <div><p class="text-xs text-slate-500 uppercase">Type</p><p id="events-view-type" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Slug</p><p id="events-view-slug" class="font-medium text-slate-900 break-all">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Starts At</p><p id="events-view-starts" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Ends At</p><p id="events-view-ends" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Timezone</p><p id="events-view-timezone" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Host</p><p id="events-view-host" class="font-medium text-slate-900">-</p></div>
        <div class="col-span-2"><p class="text-xs text-slate-500 uppercase">Location Name</p><p id="events-view-location" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Coordinates</p><p id="events-view-coordinates" class="font-medium text-primary">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Country / Region</p><p id="events-view-region" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">County</p><p id="events-view-county" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Settlement</p><p id="events-view-settlement" class="font-medium text-slate-900">-</p></div>
      </div>

      <div class="grid grid-cols-3 gap-3 text-sm">
        <div><p class="text-xs text-slate-500 uppercase">Going</p><p id="events-view-going" class="text-lg font-bold text-slate-900">0</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Interested</p><p id="events-view-interested" class="text-lg font-bold text-slate-900">0</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Not Going</p><p id="events-view-not-going" class="text-lg font-bold text-slate-900">0</p></div>
      </div>

      <div class="grid grid-cols-2 gap-3 text-sm">
        <div><p class="text-xs text-slate-500 uppercase">Capacity</p><p id="events-view-capacity" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Price From</p><p id="events-view-price" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Free Event</p><p id="events-view-free" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Meeting Point Note</p><p id="events-view-meeting-note" class="font-medium text-slate-900">-</p></div>
      </div>

      <div>
        <p class="text-xs text-slate-500 uppercase mb-1">Description</p>
        <p id="events-view-description" class="text-sm text-slate-700 whitespace-pre-wrap">-</p>
      </div>

      <div class="grid grid-cols-2 gap-3 text-sm">
        <div><p class="text-xs text-slate-500 uppercase">Moderation Comment</p><p id="events-view-moderation" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Published At</p><p id="events-view-published" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Cancelled At</p><p id="events-view-cancelled" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Finished At</p><p id="events-view-finished" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Created At</p><p id="events-view-created" class="font-medium text-slate-900">-</p></div>
        <div><p class="text-xs text-slate-500 uppercase">Updated At</p><p id="events-view-updated" class="font-medium text-slate-900">-</p></div>
      </div>

      <div class="border-t border-slate-200 pt-4">
        <div class="flex items-center justify-between mb-2">
          <p class="text-sm font-semibold text-slate-900">Messages</p>
          <p id="events-view-messages-count" class="text-xs text-slate-500">0</p>
        </div>
        <div id="events-view-messages" class="space-y-2 mb-3"></div>
        <div class="flex gap-2">
          <input id="events-view-message-input" class="flex-1 h-10 rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm focus:border-primary focus:ring-primary" placeholder="Write message..."/>
          <button id="events-view-message-send" class="h-10 px-3 rounded-lg bg-primary text-white text-sm font-semibold hover:bg-primary/90" type="button">Send</button>
        </div>
      </div>

      <div class="sticky bottom-0 bg-white pt-3 border-t border-slate-200 flex items-center gap-2">
        <button id="events-view-edit-btn" class="flex-1 h-10 rounded-lg bg-primary text-white font-semibold hover:bg-primary/90" type="button">Edit</button>
        <button id="events-view-publish-btn" class="h-10 px-3 rounded-lg border border-slate-200 text-slate-700 font-semibold hover:bg-slate-50" type="button">Publish</button>
        <button id="events-view-cancel-btn" class="h-10 px-3 rounded-lg border border-rose-200 text-rose-600 font-semibold hover:bg-rose-50" type="button">Cancel</button>
        <button id="events-view-finish-btn" class="h-10 px-3 rounded-lg border border-emerald-200 text-emerald-600 font-semibold hover:bg-emerald-50" type="button">Finish</button>
        <button id="events-view-delete-btn" class="h-10 px-3 rounded-lg border border-rose-200 text-rose-600 font-semibold hover:bg-rose-50" type="button">Delete</button>
      </div>
    </div>
  </aside>
</div>
`;
